import React, { useState, useRef, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import DoneIcon from "@mui/icons-material/Done";
import { useMediaQuery,useTheme } from "@mui/material";

function ActiveImg(props) {
  const isActive = props?.data?.imgUpldReqd;

  return (
    <div className="flex items-center justify-center">
      {isActive && <DoneIcon />}
    </div>
  );
}

function ActivePos(props) {
  const isActive = props?.data?.postnNumReqd;

  return (
    <div className="flex items-center justify-center">
      {isActive && <DoneIcon />}
    </div>
  );
}

const joinSubReasons = (value) => (Array.isArray(value) ? value.join(", ") : "");

const AoReason = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowData, setRowData] = useState([]);
  const perPage = 10;
  const [gridApi, setGridApi] = useState(null);
  const [error, setError] = useState();
  const navigate = useNavigate();
  const gridRef = useRef();
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [columnDefs, setColumnDefs] = useState([
    { field: "reason", enableRowGroup: true, headerName: "AO Reason",minWidth:100 },
    {
      field: "subReasons",
      headerName: "Sub Categories",
      flex: 1,
      minWidth: 250,
      valueGetter: (params) => joinSubReasons(params.data?.subReasons),
    },
    {
      field: "imgUpldReqd",
      enableRowGroup: true,
      headerName: "Img Required",
      cellRenderer: ActiveImg,
    },
    {
      field: "postnNumReqd",
      enableRowGroup: true,
      headerName: "POS Required",
      cellRenderer: ActivePos,
    },
  ]);
  const aoRoReasonsUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.aoRoReasons}`;

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "AoReason.xlsx",
      sheetName: "AoReason",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const getAoReason = async () => {
    gridApi?.showLoadingOverlay();
    try {
      const list = await OAuthService.getList(aoRoReasonsUrl + `?size=1000`);
      const reasons = list.data?._embedded?.aoRoReasons || [];
      setRowData(reasons);
    } catch (error) {
      setError(error.message);
    } finally {
      gridApi?.hideOverlay();
    }
  };

  useEffect(() => {
    if (gridApi) {
      getAoReason();
    }
  }, [gridApi]);

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };



const goToAoReasonEdit = useCallback(
    (data) => {
      const id = data?._links?.self?.href.split('/').pop();
      if (id) {
        navigate(`/editAoReason/${id}`);
      }
    },
    [navigate],
  );

  const onRowDoubleClicked = (params) => {
    if (isMobile) return; 
    goToAoReasonEdit(params?.data);
  };

  const onRowClicked = (params) => {
    if (!isMobile) return; 
    goToAoReasonEdit(params?.data);
  };
  return (
    <>
      <ListPageHeader
        componentName="Ao Reasons"
        onBtExport={onBtExport}
        addPageLink="/addAoReason"
        pageName="AO Reasons List"
        error={error}
        successMsg={successMsg}
        snackState={snackState}
        gridRef={gridRef}
      />
      <div className="h-full">
        <AgGridTable
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          onSelectionChanged={onSelectionChanged}
          onRowDoubleClicked={onRowDoubleClicked}
           onRowClicked={onRowClicked}
          gridRef={gridRef}
          rowData={rowData}
          paginationPageSize={perPage}
          cacheBlockSize={perPage}
          saveGridStateName={"aoReasonList"}
        />
      </div>
    </>
  );
};

export default AoReason;